import { CommonModule } from '@angular/common';
import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { InfoBannerComponent } from '@bcef/ia-components/info-banner';
import { IconsModule } from '@bcef/ia-ng-icons';
import { ContextService } from '@bcef/ia-shared';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ExpandabledItemComponent } from '@shared/components/expandabled-item/expandabled-item.component';

import { TerminationFacade } from '../../termination.facade';

@DataLayered('screens.onboarding.datalayer')
@Component({
  selector: 'ia-resil-contrats-onboarding',
  templateUrl: './onboarding.component.html',
  imports: [
    ButtonModule,
    TranslateModule,
    CommonModule,
    ExpandabledItemComponent,
    InfoBannerComponent,
    IconsModule,
  ],
})
export class OnboardingComponent implements OnInit {
  @HostBinding('class') public readonly classAttribute =
    'tw-mx-0 tw-flex tw-flex-col tw-pb-10 md:tw-mx-24 hb-group:tw-mx-7 hb-group:tw-font-hello-type hb-group:tw-mt-10 md:tw-mt-12.5 md:tw-pb-24';

  private readonly terminationFacade: TerminationFacade = inject(TerminationFacade);

  private readonly contextService = inject(ContextService);

  public ngOnInit(): void {
    this.terminationFacade.updateStepInProgress(0);
  }

  public readonly customerInformationIsLoading$: Observable<boolean> =
    this.terminationFacade.customerInformationIsLoading$;

  public onNext(): void {
    this.terminationFacade.getCustomerInformation();
  }

  public readonly isHbGroup: boolean = this.contextService.isHbGroup;
}
